import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-navbar-more",
  "use": "oc-navbar-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"oc-navbar-more\"><path d=\"M398.222222 113.777778h170.666667v170.666666H398.222222zM398.222222 398.222222h170.666667v170.666667H398.222222zM398.222222 682.666667h170.666667v170.666666H398.222222z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol